import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'Quanto tempo dura a aula?',
      answer: 'A aula tem duração de aproximadamente 90 minutos, com tempo para perguntas e respostas ao final. Você receberá o link de acesso por e-mail com antecedência.'
    },
    {
      question: 'Preciso de conhecimento técnico?',
      answer: 'Não! A aula é planejada para profissionais de todos os níveis — desde executores e mestres de obras até engenheiros e arquitetos. O conteúdo é apresentado de forma prática e acessível.'
    },
    {
      question: 'A aula será gravada?',
      answer: 'Sim! Todos os inscritos receberão acesso à gravação por 7 dias após a aula ao vivo, para que você possa rever o conteúdo e aplicar as técnicas aprendidas.'
    }
  ];

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h2 className="faq-title">Perguntas Frequentes</h2>
        <Accordion type="single" collapsible className="faq-accordion">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`} className="faq-item">
              <AccordionTrigger className="faq-question">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="faq-answer">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;